import { render, staticRenderFns } from "./MoneyInfo.vue?vue&type=template&id=86ff0b7e&scoped=true&"
import script from "./MoneyInfo.vue?vue&type=script&lang=js&"
export * from "./MoneyInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoneyInfo.vue?vue&type=style&index=0&id=86ff0b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff0b7e",
  null
  
)

export default component.exports